import React, { useEffect, useRef, useState } from 'react';
import {
  StyleSheet,
  Text,
  TouchableOpacity,
  Image,
  View,
  Platform,
  useWindowDimensions,
} from 'react-native';
import { ScreenProps } from '../../../typesInterfacesEnums/componentProps';
import { ComponentWrapper } from '../../helperComponents/ComponentWrapper';
import { Divider } from '../../helperComponents/Divider';
import { ErrorPopup } from '../../helperComponents/ErrorPopup';
import { applyTransparency } from '../../../constants/colors';
import { useSignedInContext } from '../../../context/SignedInContext';
import { DropdownMenu } from '../../helperComponents/DropdownMenu/DropdownMenu';
import { mbPlatformStyle, mbTextStyles } from '@mightybyte/rnw.utils.style-utils';
import { USER_TYPES } from '../../../typesInterfacesEnums/enums';
import AsyncStorage from '@react-native-async-storage/async-storage';
import LinearGradient from 'react-native-linear-gradient';
import { HiveGymLobby } from './HiveGymLobby';
import { PlayAFriendLobby } from './PlayAFriendLobby';
import { YourPoints } from '../../helperComponents/YourPoints';
import { textStyles } from '../../../constants/textStyles';
import { getVersionNumber } from '../../../utils/getVersionNumber/getVersionNumber';
import { useGetBackendVersion } from '../../../hooks/serverUtilHooks';
import { envs } from '../../../../env';
import { HomeButton } from '../../helperComponents/HomeButton';
import MainLobby from './MainLobby';
import { isMobileApp } from '@mightybyte/rnw.utils.device-info';
import LabelCountBox from '../../helperComponents/LabelCountBox';
import NectarNook from '../../helperComponents/NectarNook';
import { TooltipSequence } from '../../helperComponents/ToolTip/ToolTipSequence';

const versions = getVersionNumber();

const hiveIcon = require('../../../resources/images/hiveIcon.png');

const Lobby = ({ navigation, route }: ScreenProps<'Lobby'>) => {
  const { isSignedIn, user } = useSignedInContext();
  const [playingName, setPlayingName] = useState<string | undefined>(undefined);

  const { data: serverVersion } = useGetBackendVersion();

  const routeParams = route.params;

  const { width } = useWindowDimensions();
  const pathSizeLimit = width < 1251;
  const isMobileWeb = Platform.OS === 'web' && width <= 768;
  const isMobileApp = Platform.OS === 'ios' || Platform.OS === 'android';

  const nectarCount = user?.points ?? 0;

  const nectarCountRef = useRef<View>(null);
  const nectarCountMobileRef = useRef<View>(null);
  const dropdownMenuRef = useRef<View>(null);

  useEffect(() => {
    if (isSignedIn) {
      if (user) {
        if (user.userType === USER_TYPES.teacher) {
          setPlayingName(user.firstName);
        } else {
          setPlayingName(user.email);
        }
      }
    } else {
      AsyncStorage.getItem('playing-name').then(res => {
        if (res) {
          setPlayingName(res);
        } else {
          setPlayingName(undefined);
        }
      });
    }
  }, [isSignedIn, user]);

  const [hasError, setHasError] = useState({
    visible: false,
    popup: false,
    text: '',
  });

  return (
    <>
      <ComponentWrapper hasInset hasScroll={false}>
        {/*<ResultPopup visible={true} setVisible={()=>{}} onPressAction={()=>{}} isWinner={false} isDraw={false} isPassAndPlay={false}*/}
        {/*             handlePlayAgainPress={()=>{}} anotherPlayerLeft={false} winnerName={undefined}/>*/}

        {routeParams?.playAFriend && <Divider empty height={isMobileWeb ? 100 : 40} />}
        {isMobileWeb && <Divider empty height={200} />}
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: 20,
            width: '100%',
          }}
          ref={nectarCountMobileRef}
        >
          {pathSizeLimit && (
            <View style={[styles.nectarButtonsContainerMobile]}>
              <View style={{ position: 'relative' }}>
                <LabelCountBox
                  borderColor1="#FFF5DD"
                  borderColor2="#FFF5DD"
                  width={159.18}
                  height={51.77}
                  gradientBorderHeight={56}
                  backgroundColor="#FCEABB"
                  backgroundColorCount="#FEDD88"
                  countText={String(nectarCount)}
                />
              </View>

              <NectarNook
                borderColor1="#FFF5DD"
                borderColor2="#FFF5DD"
                width={159.18}
                height={51.77}
                gradientBorderHeight={56}
                backgroundColor="#FCEABB"
                backgroundColorIcon="#FEDD88"
                navigation={navigation}
              />
            </View>
          )}
        </View>

        {user ? <YourPoints points={user?.points} /> : null}
        <Divider empty height={20} />
        <Image style={styles.image} source={hiveIcon} resizeMode="contain" />
        <Divider empty height={20} />

        {!routeParams ? (
          <MainLobby navigation={navigation} playingName={playingName} />
        ) : routeParams && routeParams?.playAFriend ? (
          <PlayAFriendLobby navigation={navigation} playingName={playingName} />
        ) : (
          <HiveGymLobby navigation={navigation} playingName={playingName} />
        )}

        <View
          style={{
            position: 'absolute',
            right: 0,
            bottom: isMobileWeb ? -150 : 0,
            paddingEnd: 8,
            paddingBottom: 4,
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
          }}
        >
          <Text style={styles.versionInfoText}>
            JS Version: {versions.jsVersion}({envs.ENV.charAt(0).toUpperCase()})
          </Text>
          {Platform.OS !== 'web' && (
            <Text style={styles.versionInfoText}>
              App Version: {`${versions.appVersion}(${versions.buildVersion})`}
            </Text>
          )}
          <Text style={styles.versionInfoText}>Server Version: {serverVersion}</Text>
        </View>
      </ComponentWrapper>
      {isSignedIn ? (
        <>
          <View style={{ position: 'absolute', top: 0, left: 0 }} ref={dropdownMenuRef}></View>
          <DropdownMenu
            backButton={
              routeParams ? <HomeButton onPress={() => navigation.navigate('Lobby')} /> : undefined
            }
          />

          {!routeParams?.playAFriend &&
            !routeParams?.gym &&
            user?.userType === USER_TYPES.student && (
              <TouchableOpacity
                style={[
                  styles.myHivesContainer,
                  {
                    top: isMobileApp ? 20 : isMobileWeb ? 10 : !pathSizeLimit ? 120 : 125,
                    right: !pathSizeLimit ? undefined : styles.myHivesContainer.right,
                    left: !pathSizeLimit ? 220 : undefined,
                  },
                ]}
                onPress={() => navigation.navigate('MyHives')}
              >
                <LinearGradient
                  style={[styles.nameContainer, isMobileWeb && { width: 110 }]}
                  colors={['#FFCF53', '#FF9900']}
                >
                  <Text maxFontSizeMultiplier={1} style={styles.myHivesText}>
                    My Hives
                  </Text>
                </LinearGradient>
              </TouchableOpacity>
            )}

          {!pathSizeLimit && (
            <View ref={nectarCountRef} style={[styles.nectarButtonsContainer]}>
              <View style={{ position: 'relative' }}>
                <TooltipSequence
                  stage={2}
                  backgroundColor="rgba(240, 236, 7, 0.25)"
                  borderColor="rgba(255, 255, 255, 0.4)"
                  borderWidth={5}
                />
                <LabelCountBox countText={String(nectarCount)} />
              </View>
              <NectarNook navigation={navigation} />
            </View>
          )}

          <TooltipSequence stage={0} backgroundColor="rgba(0,0,0,0.25)" />
        </>
      ) : (
        <View
          style={[
            styles.loginContainer,
            { flexDirection: 'row' },
            isMobileApp ? { top: 20 } : isMobileWeb && { top: 10, left: 20 },
          ]}
        >
          <TouchableOpacity
            style={styles.loginButton}
            onPress={() => navigation.navigate('SignIn')}
          >
            <LinearGradient style={styles.nameContainer} colors={['#FFCF53', '#FF9900']}>
              <Text maxFontSizeMultiplier={1} style={styles.loginText}>
                Login
              </Text>
            </LinearGradient>
          </TouchableOpacity>
          {routeParams?.playAFriend && (
            <>
              <HomeButton onPress={() => navigation.navigate('Lobby')} />
            </>
          )}
        </View>
      )}
      <ErrorPopup
        isVisible={hasError.popup}
        setVisible={() => setHasError(v => ({ ...v, popup: false }))}
        text={hasError.text}
      />
    </>
  );
};

export { Lobby };

const styles = StyleSheet.create({
  image: { width: 180, height: 100 },
  howToPlayText: {
    fontFamily: 'Secular One',
    fontSize: 20,
    color: 'black',
    textDecorationLine: 'underline',
  },
  loginContainer: {
    alignItems: 'center',
    ...mbPlatformStyle({
      mobile: {
        left: 20,
      },
      web: {
        left: 60,
      },
    }),
    position: 'absolute',
    top: 120,
  },
  loginButton: {
    marginRight: 16,
  },
  loginText: {
    fontFamily: 'Secular One',
    marginLeft: 6,
    fontSize: 20,
    marginTop: 4,
    color: '#453B3B',
    textShadowColor: applyTransparency('#000000', 0.15),
    textShadowOffset: { width: 0, height: 3 },
    textShadowRadius: 2,
  },
  myHivesContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    ...mbPlatformStyle({
      mobile: {
        right: 20,
      },
      web: {
        right: 60,
      },
    }),
    position: 'absolute',
    top: 60,
  },
  myHivesText: {
    fontFamily: 'Secular One',
    marginRight: 6,
    fontSize: 16,
    marginTop: 4,
    color: '#000000',
  },
  nameContainer: {
    borderRadius: 12,
    width: 140,
    height: 51,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  name: {
    fontFamily: 'Secular One',
    fontSize: 18,
    color: '#453B3B',
    textShadowColor: applyTransparency('#000000', 0.15),
    textShadowOffset: { width: 0, height: 3 },
    textShadowRadius: 2,
  },
  logoutText: {
    marginLeft: 4,
    fontFamily: 'Secular One',
    fontSize: 20,
    color: '#453B3B',
    textShadowColor: applyTransparency('#000000', 0.15),
    textShadowOffset: { width: 0, height: 3 },
    textShadowRadius: 2,
  },
  versionInfoText: {
    ...mbTextStyles(
      {
        ...textStyles.smallerText,
        alignSelf: 'flex-start',
        color: 'black',
        fontSize: 10,
        lineHeight: 12,
      },
      { allowLineHeight: true },
    ),
  },
  nectarButtonsContainer: {
    position: 'absolute',
    top: 125,
    right: 20,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 20,
  },
  nectarButtonsContainerMobile: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 20,
    position: 'relative',
    marginTop: 60,
  },
});
